import React from 'react';

const FileRow = ({ file, handleFileClick }) => {
	return (
		<div className="file-table__row">
			<span className="file-table__row-title" dangerouslySetInnerHTML={{__html: file.title}} />
			<span className="file-table__row-date">{file.date}</span>
			<span className="file-table__row-links">
				<a href={file.file} target="_blank" onClick={() => handleFileClick(file.id)}>View</a> 
				<span>|</span> 
				<a href={file.file} download onClick={() => handleFileClick(file.id)}>Download</a>
			</span>
		</div>
	);
};

export default FileRow;


// WEBPACK FOOTER //
// ./src/components/common/files/FileTable/FileRow.js